import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getSuppliers() {
    yield takeEvery(actions.FETCH_SUPPLIERS_REQUESTED, function* (action) {
        try {
          const suppliers = yield call(actions.getSuppliers, action.payload);
          yield put({ type: actions.FETCH_SUPPLIERS_SUCCEEDED, suppliers });
        } catch (error) {
          yield put({ type: actions.FETCH_SUPPLIERS_FAILED, error: error.message });
        }
    });
}

export function* approveSupplier() {
  yield takeEvery(actions.APPROVE_SUPPLIER_REQUESTED, function* (action) {
      try {
        const response = yield call(actions.approveSupplierApi, action.payload);
        yield put({ type: actions.APPROVE_SUPPLIER_SUCCEEDED, response });
      } catch (error) {
        yield put({ type: actions.APPROVE_SUPPLIER_FAILED, error: error?.response?.data?.message });
      }
  });
}


export function* getOrdersAnalytics() {
    yield takeEvery(actions.FETCH_ORDERS_ANALYTICS_REQUESTED, function* (action) {
        try {
            const ordersAnalytics = yield call(actions.getOrdersAnalytics, action.payload);
            yield put({ type: actions.FETCH_ORDERS_ANALYTICS_SUCCEEDED, ordersAnalytics });
        } catch (error) {
            yield put({ type: actions.FETCH_ORDERS_ANALYTICS_FAILED, error: error?.response?.data?.message });
        }
    });
}


export function* getRevenueAnalytics() {
    yield takeEvery(actions.FETCH_REVENUE_REQUESTED, function* (action) {
        try {
            const revenueAnalytics = yield call(actions.getRevenueAnalytics, action.payload);
            yield put({ type: actions.FETCH_REVENUE_SUCCEEDED, revenueAnalytics });
        } catch (error) {
            yield put({ type: actions.FETCH_REVENUE_FAILED, error: error?.response?.data?.message });
        }
    });
}


export default function* rootSaga() {
    yield all([
        fork(getSuppliers),
        fork(approveSupplier),
        fork(getOrdersAnalytics),
        fork(getRevenueAnalytics)
     ])
}
